/* eslint jsx-a11y/aria-role:0 */
import React, { Component } from 'react';
import './style.css';

class QuantityPicker extends Component {
  getSecondaryColor = () => `#${this.props.secondaryColor}`;

  getButtonStyle = () => ({ color: this.getSecondaryColor(), borderColor: this.getSecondaryColor() })

  handleAddition = () => {
    if (this.props.count < this.props.max) this.props.onChange(this.props.count + 1);
  }

  handleSubstraction = () => {
    if (this.props.count > 1) {
      this.props.onChange(this.props.count - 1);
    }
  }

  isNext = () => this.props.count < this.props.max

  isPrev = () => this.props.count > 1

  render() {
    return (
      <div className="quantity-picker">
        <div className="operator-wrapper">
          <div
            style={{ ...this.getButtonStyle(), ...{ opacity: (this.isPrev() ? '1' : '0.4') } }}
            onClick={this.handleSubstraction}
            className="operator"
            role="decreaseAmt"
          >
            &minus;
          </div>
          <div className="amt">
            Quantity:
            <div className="qnt" style={{ marginLeft: 4 }}>{this.props.count}</div>
          </div>
          <div
            style={{ ...this.getButtonStyle(), ...{ opacity: (this.isNext() ? '1' : '0.4') } }}
            onClick={this.handleAddition}
            className="operator"
            role="increaseAmt"
          >
            &#43;
          </div>
        </div>
      </div>
    );
  }
}

export { QuantityPicker };



// WEBPACK FOOTER //
// ./src/components/QuantityPicker/QuantityPicker.jsx